// extracted by mini-css-extract-plugin
module.exports = {"feedTable":"_d2d34bc"};